import React, {
    useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import { AdditionalInterestComponent, CoverageComponent } from "premier-capability-policyjob-react";
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { PremierConstants } from 'premier-constant-service';
import { useUpdateSubmissionServices } from 'premier-capability-hooks';
import metadata from './CoveragesPage.metadata.json5';
import messages from './CoveragesPage.messages.js';
import styles from '../../components/EnvImpairment/envImpairment.module.scss'

function CoveragesPage(props) {

    const { wizardData: submissionVM, updateWizardData } = props;
    const { lineName } = PremierConstants;
    const { updateSubmission } = useUpdateSubmissionServices();

    const { authHeader } = useAuthentication();
    const {
        onValidate,
        initialValidation
    } = useValidation('CoveragesPage');


    useEffect(() => {

    }, []);

    const onNext = useCallback(
            async () => {
                const productCode = _.get(submissionVM.value, 'baseData.productCode');
                // eslint-disable-next-line security/detect-object-injection
                const lobLineName = productCode ? lineName[productCode] : '';
                const response = await updateSubmission(lobLineName, 'EnvEmpairmentPage', submissionVM);
    
                submissionVM.value = response;
    
                return submissionVM;
            },
            [lineName, submissionVM, updateSubmission]
        );

    const overrideProps = {
        pplLineCoverageComponent: {
            wizardData: submissionVM,
            updateWizardData,
            clausesBasePath: `lobData.envLin.lineCoverages.coverages`,
            title: messages.covMiscellaneous,
            clasueType: 'coverages',
            pathToGet: 'envLin.coverages'
        },
        additionalInterest:{
            value: submissionVM,
            path: `lobData.envLin.coverables.additionalInterests`,
            type: 'additionalInterest',
            onValueChange: updateWizardData,
            authHeader
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            coveragespagecomponent: CoverageComponent,
            additionalInterestComponent: AdditionalInterestComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [metadata, submissionVM, overrideProps]
    );


    const isDisableNext = () => !submissionVM.lobData.envLin.coverables.additionalInterests.aspects.subtreeValid

    return (
        <WizardPage skipWhen={initialValidation} onNext={onNext} onSave={onNext} disableNext={isDisableNext()} disableSave={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

CoveragesPage.propTypes = wizardProps;
export default withRouter(CoveragesPage);
